/** Duty & tax estimate (moderator side): the same estimator companies use. */
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import ModeratorLayout from "@/components/ModeratorLayout/ModeratorLayout";
import TradeEstimateTool from "@/components/TradeEstimate/TradeEstimateTool";
import "./ModeratorPage.css";

const ModeratorTradeEstimatePage = () => {
  const { t } = useTranslation("trade");
  const [params] = useSearchParams();
  return (
    <ModeratorLayout>
      <header className="mod-page__header">
        <div>
          <h1 className="mod-page__title">{t("tool.title")}</h1>
          <p className="mod-page__subtitle">{t("tool.subtitle")}</p>
        </div>
      </header>
      <TradeEstimateTool initialHsCode={params.get("hs") ?? ""} />
    </ModeratorLayout>
  );
};

export default ModeratorTradeEstimatePage;
